import React from 'react';
import { Typography } from 'seagull';
import styles from "./MapContactsModal.module.scss";
export const columnDefs = [{
  width: 400
}, // Anchor contacts
{
  width: 400
}, // QuickBooks Online customers
{
  width: 260
} // Status
];
export const headerItems = [{
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "Anchor contact"))
}, {
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "QuickBooks Online customer"))
}, {
  value: 'Status'
}];
export let QboCustomersDropdownOptionType;

(function (QboCustomersDropdownOptionType) {
  QboCustomersDropdownOptionType["CreateNew"] = "createNew";
  QboCustomersDropdownOptionType["Existing"] = "existing";
})(QboCustomersDropdownOptionType || (QboCustomersDropdownOptionType = {}));

export let FailureReasons;

(function (FailureReasons) {
  FailureReasons["General"] = "general";
  FailureReasons["DuplicateMapping"] = "duplicateMapping";
  FailureReasons["DuplicateNew"] = "duplicateNew";
})(FailureReasons || (FailureReasons = {}));